{
  "loading": "Laden...",
  "placeholder": "Optie selecteren..."
}
